import { Component } from '@angular/core';
import * as moment from 'moment';
import { LeituraEstacaoDiaService } from 'src/services/leitura-estacao-dia.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-leitura-estacao-dialog',
  templateUrl: './leitura-estacao-dialog.component.html',
  styleUrls: ['./leitura-estacao-dialog.component.scss'],
  standalone: false,
})
export class LeituraEstacaoDialogComponent {
  visible = false;
  loading = false;
  dadosVariavel: any[] = [];
  columnsVariavel: { field: string; header: string }[] = [];
  descricaoEstacao = '';
  estacaoColetas: any[] = [];
  titulo = '';
  dadosNaoEncontrados = false;

  private estacaoId: number | null = null;
  private dataResumo = '';

  constructor(
    private leituraEstacaoDiaService: LeituraEstacaoDiaService,
    private messageService: MessageService,
  ) {}

  abrir(params: { estacaoId: number; dataResumo: string; estacaoDescricao?: string }): void {
    const estacaoId = Number(params.estacaoId);
    const dataResumo = moment(params.dataResumo).format('YYYY-MM-DD');

    if (!estacaoId || dataResumo === 'Invalid date') {
      return;
    }

    this.estacaoId = estacaoId;
    this.dataResumo = dataResumo;
    this.visible = true;
    this.loading = true;
    this.dadosVariavel = [];
    this.columnsVariavel = [];
    this.estacaoColetas = [];
    this.dadosNaoEncontrados = false;
    this.titulo = `${params.estacaoDescricao || 'Estação'} | Leituras ${moment(dataResumo).format('DD/MM/YYYY')}`;

    this.leituraEstacaoDiaService.carregar(estacaoId, dataResumo).subscribe({
      next: (resultado) => {
        this.dadosVariavel = resultado.dadosVariavel;
        this.columnsVariavel = resultado.columnsVariavel;
        this.descricaoEstacao = resultado.descricaoEstacao;
        this.estacaoColetas = resultado.estacaoColetas;
        this.dadosNaoEncontrados = this.dadosVariavel.length === 0;
        if (resultado.descricaoEstacao) {
          this.titulo = `${resultado.descricaoEstacao} | Leituras ${moment(dataResumo).format('DD/MM/YYYY')}`;
        }
        this.loading = false;
      },
      error: () => {
        this.loading = false;
        this.dadosNaoEncontrados = true;
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Não foi possível carregar as leituras da estação.',
        });
      },
    });
  }
}
